<template>
  <div class="">
    <!-- <FinancialData /> -->

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Student History Search</div>
          <div class="panal-body">
            <b-row>
              <b-col md="6" sm="12" v-b-tooltip.hover title="Start Due Date">
                <label for="example-datepicker" >Start Due Date</label>
                <b-form-datepicker
                  id="Start"
                  v-model="startDate"
                  class="mb-2"
                ></b-form-datepicker>
              </b-col>
              <b-col md="6" sm="12" v-b-tooltip.hover title="End Due Date">
                <label for="example-datepicker" >End Due Date</label>
                <b-form-datepicker
                  id="End"
                  class="mb-2"
                  v-model="endDate"
                ></b-form-datepicker>
              </b-col>
              <b-col  sm="12" class="mt-3 text-center">
                <b-form-radio-group v-model="search">
                  <!-- <b-form-radio value="" checked>All</b-form-radio> -->
                  <b-form-radio value="0" v-b-tooltip.hover title="Debit">Debit</b-form-radio>
                  <b-form-radio value="1" v-b-tooltip.hover title="Credit">Credit</b-form-radio>
                </b-form-radio-group>
                <div class="mt-3 text-right">
                  <b-button @click="GetHistroty" variant="success"
                    :disabled='isDisabled'>Search</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Financial History</div>
          <div class="panal-body">

        <div class="text-center" v-if="loading ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

            <div class="table-responsive">               
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Payment Type</th>
                    <th scope="col">Credit/Debit</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Due Date</th>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Charge Status</th>
                    <th scope="col">Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="empty">
                    <td colspan="7">No Data</td>
                  </tr>
                  <tr
                    v-else
                    v-for="item in financialHistoryPaged"
                    v-bind:Key="item.StudentID"
                  >
                    <td>{{ item.PaymentType }}</td>

                    <td>
                      <span
                        class="badge-success badge"
                        :class="{
                          'badge-warning':
                            (item, item.CreditOrDebit == 'Debit'),
                        }"
                        >{{ item.CreditOrDebit }}</span
                      >
                    </td>
                    <td>{{ item.Amount | toCurrency }}</td>
                    <td>{{ item.DueDate }}</td>
                    <td>
                      {{
                        item.PaymentDate == "1/1/0001" ? "--" : item.PaymentDate
                      }}
                    </td>
                    <td>{{ item.ChargeStatus }}</td>
                    <td>{{ item.Notes }}</td>
                  </tr>
                </tbody>
              </table>
              <p v-if="!empty">
                <button
                  @click="prevPage"
                  class="btn btn-primary"
                  :disabled="currentPage == 1"
                >
                  {{ currentPage == 1 ? "First" : "previous" }}
                </button>
                {{ currentPage }} of
                {{ (FinancialHistory.length / pageSize).toFixed() }}
                <button
                  class="btn btn-primary"
                  @click="nextPage"
                  :disabled="
                    currentPage ==
                      (FinancialHistory.length / pageSize).toFixed()
                  "
                >
                  {{
                    currentPage ==
                    (FinancialHistory.length / pageSize).toFixed()
                      ? "Last"
                      : "next"
                  }}
                </button>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import FinancialData from "../../components/Financial/FinancialData.vue";
import studentData from "../../services/student/studentDataServices";
export default {
  components: {
    // FinancialData,
  },
  name: "StudentHistorySearch",
  data() {
    return {
      selected: null,
      show: true,
      isHidden: false,
      FinancialHistory: [],
      search: null,
      empty: true,
      endDate: "1/1/0001",
      startDate: "1/1/0001",

      pageSize:5,
      currentPage:1,
      loading : false, 
      isDisabled: false,  
    };
  },

  computed: {
    currenUser() {
      return this.$store.state.auth.user;      
    },

      financialHistoryPaged(){
             return this.FinancialHistory.map(item => item).filter((row, index) => {
              let start = (this.currentPage-1)*this.pageSize;
              let end = this.currentPage*this.pageSize;
              if(index >= start && index < end) return true;
            });
            },

    paymentMethod: function() {
      return this.FinancialHistory.filter((item) => {
        return item.CreditOrDebit.match(this.search);
      });
    },

    //  filterDate: function () {

    //    var vm = this
    //    var startDate = vm.startDate;
    //    var endDate = vm.endDate;
    //    return FinancialHistory.filter(vm.FinancialHistory.item,(function(FinancialHistory){
    //      if((startDate) && (endDate)){
    //         return true
    //      }
    //       else {
    //      var date= FinancialHistory.date;
    //      return (date >= startDate && date <= endDate);
    //    }
    //    }

    //    ))

    //  }
  },

  methods: {
    GetHistroty() {
       this.loading = true;
       this.isDisabled =  true;
       this.empty= true
      this.FinancialHistory = [];
      studentData
        .GetStudentFinancialHistory(
          this.currenUser.StudentID,
          this.startDate,
          this.endDate,
          this.search
        )
        .then(
          (Response) => {
           
            this.FinancialHistory = Response.data;
            this.empty = this.FinancialHistory.length > 0 ? false : true;
            this.loading = false;
            this.isDisabled = false;
            //Response.OnlineReceipt
            // eslint-disable-next-line no-console
          //  console.log("StudentFinancialHistory => ", this.FinancialHistory);
          },
          (error) => {
            // eslint-disable-next-line no-console
           // console.log(error.response.status);
            this.empty = true;
            this.loading = false;
            this.isDisabled = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.Message) ||
              error.message ||
              error.toString();

            if (error.response.status == 404) this.message = "";
          }
        );
    
    },

    nextPage:function() {
      if((this.currentPage*this.pageSize) < this.FinancialHistory.length) this.currentPage++;
    },

    prevPage:function() {
      if(this.currentPage > 1) this.currentPage--;
    }
  },

  mounted() {
    //this.currenUser.StudentID  // 4
    //     studentData.GetStudentFinancialHistory(this.currenUser.StudentID,'1/1/0001','1/1/0001',null).then(Response =>{
    //       // this.isLoading = false ;
    //        this.FinancialHistory = Response.data
    //        // this.empty =false
    //        //Response.OnlineReceipt
    //         // eslint-disable-next-line no-console
    //           console.log('StudentFinancialHistory => ',this.FinancialHistory )
    //    },
    //  error => {
    //           // eslint-disable-next-line no-console
    //           console.log(error.response.status)
    //       this.message =
    //         (error.response && error.response.data && error.response.data.Message) ||
    //         error.message ||
    //         error.toString();
    //         if(error.response.status == 404) this.message =''
    //     })
   
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
.badge {
  padding: 0.65em 0.6em;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none;
  }
}
</style>
